'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var locale = {
  placeholder: 'Vælg tid'
};

exports['default'] = locale;